import { ButtonGroup } from "react-bootstrap";
import { ArrowLeftIcon, ArrowRightIcon } from "../icons.jsx";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { Button } from "../Button.tsx";

export const FullCalendarMonthSwitcher = ({ calendarRef }) => {
  /** @type {import("@fullcalendar/core").CalendarApi} */
  const calendarApi = calendarRef.getApi();

  const todayDate = DateTime.now();
  const calendarDate = DateTime.fromJSDate(calendarApi.getDate());
  const { t } = useTranslation();
  const isToday = todayDate.month === calendarDate.month && todayDate.year === calendarDate.year;

  return (
    <ButtonGroup aria-label="Basic example" className="bg-white">
      <Button
        testId="prev-month"
        variant="outline-secondary"
        className="px-3 border-right-0"
        onClick={() => calendarApi.prev()}
      >
        <ArrowLeftIcon />
      </Button>
      <Button
        testId="today"
        variant="outline-secondary"
        active={isToday}
        className="px-3 fw-bold border-left-0 border-right-0"
        onClick={() => calendarApi.today()}
      >
        {t("Today", "Tänään")}
      </Button>
      <Button
        testId="next-month"
        variant="outline-secondary"
        className="px-3 border-left-0"
        onClick={() => calendarApi.next()}
      >
        <ArrowRightIcon />
      </Button>
    </ButtonGroup>
  );
};
